import React from 'react';
import { useSubscriptionStatus } from '../hooks/useSubscriptionStatus';

const SubscriptionDebug = () => {
  const {
    isSubscribed,
    isLoading,
    error,
    subscriptionStatus,
    isPro,
    subscriptionId,
    currentPeriodEnd,
    planType,
    stripeCustomerId,
    subscriptionExpired,
    lastChecked,
    refreshSubscriptionStatus,
    syncWithStripe
  } = useSubscriptionStatus();

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const handleRefresh = async () => {
    console.log('Manually refreshing subscription status...');
    await refreshSubscriptionStatus();
  };

  const handleSync = async () => {
    console.log('Manually syncing with Stripe...');
    await syncWithStripe();
  };

  return (
    <div className="fixed bottom-4 right-4 z-[10000] bg-black/90 text-white p-4 rounded-lg text-xs max-w-sm border border-gray-600">
      <h4 className="font-bold mb-2 text-klorah-primary">Sessions Subscription Debug</h4>
      <div className="space-y-1 mb-3">
        <div>Status: <span className={isSubscribed ? 'text-emerald-400' : 'text-red-400'}>{isSubscribed ? 'Active' : 'Inactive'}</span></div>
        <div>Loading: {isLoading ? 'Yes' : 'No'}</div>
        <div>Pro: {isPro ? 'Yes' : 'No'}</div>
        <div>Subscription Status: {subscriptionStatus || 'None'}</div>
        <div>Plan Type: {planType || 'None'}</div>
        <div>Subscription ID: {subscriptionId ? subscriptionId.substring(0, 20) + '...' : 'None'}</div>
        <div>Customer ID: {stripeCustomerId ? stripeCustomerId.substring(0, 20) + '...' : 'None'}</div>
        {currentPeriodEnd && <div>Period End: {new Date(currentPeriodEnd).toLocaleDateString()}</div>}
        {subscriptionExpired && <div className="text-red-400">Subscription Expired</div>}
        {error && <div className="text-red-400">Error: {error}</div>}
        <div>Last Checked: {lastChecked ? new Date(lastChecked).toLocaleTimeString() : 'Never'}</div>
      </div>
      
      <div className="flex gap-2">
        <button 
          onClick={handleRefresh} 
          className="px-2 py-1 bg-klorah-primary text-black rounded text-xs hover:bg-klorah-primary/80"
          disabled={isLoading}
        >
          Refresh
        </button>
        <button 
          onClick={handleSync} 
          className="px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
          disabled={isLoading}
        >
          Sync
        </button>
      </div>
    </div>
  );
};

export default SubscriptionDebug; 